import { useSiteConfig } from "@/hooks/useSiteConfig";
import tropuncaLogo from "@/assets/tropunca-logo.png";

const LogoText = ({ className = "h-12", useFooterLogo = false }: { className?: string; useFooterLogo?: boolean }) => {
  const { getConfig } = useSiteConfig();
  
  const logoConfig = getConfig(useFooterLogo ? 'footer_logo' : 'header_logo');
  const logoUrl = logoConfig?.url || tropuncaLogo;
  const logoAlt = logoConfig?.alt || 'TROPUNCA VIP';

  return (
    <div className={`${className} flex items-center`}>
      <img 
        src={logoUrl} 
        alt={logoAlt}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};

export default LogoText;
